import {createAction} from 'redux-act';

// eslint-disable-next-line import/prefer-default-export
export const PATCH_USER_BANK_INFO = createAction(
  'analyticsCustomersCount/GET_CUSTOMERS_COUNT'
);
